var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"rewards-status",class:_vm.rewardsStatusComputedClass},[_c('p',{staticClass:"rewards-status__text",class:_vm.textComputedClass},[_vm._v(" "+_vm._s(_vm.text)+" ")]),(_vm.isShowDescription)?_c('p',[_vm._v(" "+_vm._s(_vm.$t('rewards.rewardsStatusDescription'))+" ")]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }